import {
  getMaxSkewYBounds,
  getTravelMap,
  TRAVEL_TYPES,
} from '../../../utils/animationsUtils';
import { AnimationProperties, AnimationsKit } from '../../../types';

const name = 'BgSkew';
const angle = 20;
const properties: AnimationProperties = {
  hideOnStart: false,
  getMediaDimensions(width: number, height: number) {
    return getMaxSkewYBounds(width, height, angle);
  },
  groups: ['animation', 'background'],
  schema: {
    duration: {
      type: 'number',
      min: 0,
      default: 0,
    },
    delay: {
      type: 'number',
      min: 0,
      default: 0,
    },
  },
};

function animate(
  kit: AnimationsKit,
  elements: HTMLElement[],
  duration: number,
  delay: number,
  {
    componentHeight,
    componentTop,
    siteHeight,
    viewPortHeight,
    ...params
  }: any = {},
) {
  const sequence = kit.sequence(params);
  const { TOP_TO_BOTTOM, CENTER_TO_CENTER, BOTTOM_TO_TOP, isInFirstFold } =
    getTravelMap(
      componentHeight,
      componentTop,
      siteHeight,
      viewPortHeight,
      TRAVEL_TYPES.normal,
    );

  const animationParams = {
    out: {
      start: CENTER_TO_CENTER,
      end: BOTTOM_TO_TOP,
      skewY: -angle,
      ease: 'none',
    },
    // if in first fold skip the in animation, start with no skew
    in: isInFirstFold
      ? undefined
      : {
          start: TOP_TO_BOTTOM,
          end: CENTER_TO_CENTER,
          skewY: angle,
          ease: 'none',
        },
  };

  sequence.add([
    kit.animate('BaseBgSkew', elements, duration, delay, animationParams),
  ]);

  return sequence.get();
}

export { name, properties, animate };
